<template>
  <apexchart
    type="bar"
    ref="chart"
    :height="'70%'"
    :options="chartOptions"
    :series="series"
    class="chart-wrapper"
  />
</template>

<script>
export default {
  name: "stackColumn",
  props: {
    data_chart: {
      type: Object,
      required: true,
    },
  },

  data() {
    const { safeSeries, safeCategorias } = this.prepareData(this.data_chart);

    return {
      series: safeSeries,
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: { show: false },
          fontFamily: "Helvetica, Arial, sans-serif",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "85%",
          },
        },
        colors: ["#103E8E", "#5390EA", "#79A6E8"],
        xaxis: {
          categories: safeCategorias,
          min: 0,
          max: 100,
        },
        yaxis: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          formatter: val => `${val.toFixed(1)}%`,
        },
      },
    };
  },

  watch: {
    data_chart: {
      deep: true,
      handler(newVal) {
        const { safeSeries, safeCategorias } = this.prepareData(newVal);

        this.series = safeSeries;
        this.chartOptions.xaxis.categories = safeCategorias;

        if (this.$refs.chart) {
          this.$refs.chart.updateOptions(
            { xaxis: { categories: safeCategorias } },
            false,
            true
          );
          this.$refs.chart.updateSeries(safeSeries, true);
        }
      },
    },
  },

  methods: {
    prepareData(data) {
      // fallbacks seguros
      const categorias = data.categorias || ["Propiedad"];
      const inputSeries = data.series || [];

      const safeSeries = inputSeries.map(s => {
        const safeData = (s.data || []).map(v => {
          const n = Number(String(v).replace(/[^0-9.-]/g, ""));
          return isNaN(n) ? 0 : n;
        });

        return {
          name: s.name || "Serie",
          data: safeData,
        };
      });

      return {
        safeSeries,
        safeCategorias: categorias,
      };
    },
  },
};
</script>

<style scoped>
.chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
</style>
